module.exports = __webpack_public_path__ + "static/media/lexus_logo2.8d5a4db8.png";